import { useEffect } from "react";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "@/lib/whatsapp";

const BOOKING_URL = "https://calendly.com/asesor-coressenglobal/llamada";

const CalendlySection = () => {
  useEffect(() => {
    const src = "https://assets.calendly.com/assets/external/widget.js";
    if (document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section
      id="calendly"
      className="py-20 md:py-28 relative overflow-hidden"
    >
      {/* Background gradient */}
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(180deg, #0a1628 0%, #1e3a5f 100%)" }}
      />
      {/* Glow accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full blur-3xl opacity-20 pointer-events-none" style={{ backgroundColor: "#3b82f6" }} />

      <div className="container px-4 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-8"
        >
          <span className="text-xs md:text-sm font-semibold tracking-[0.3em] uppercase text-blue-400 block mb-4">
            Agendá tu Llamada
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Reservá tu{" "}
            <span
              className="italic bg-clip-text text-transparent"
              style={{ backgroundImage: "linear-gradient(135deg, #60a5fa 0%, #93c5fd 100%)" }}
            >
              Llamada Estratégica
            </span>
          </h2>
          <p className="text-sm md:text-base italic text-white/60 mt-5">
            *Sólo para marcas con amplia trayectoria que estén dispuestas a invertir en su crecimiento. · Llamada de 30 min · Sólo 3 cupos al mes
          </p>
        </motion.div>

        {/* Calendly inline embed */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-3xl mx-auto"
        >
          <div className="rounded-3xl overflow-hidden border border-blue-400/30 bg-white shadow-[0_8px_60px_hsl(217,91%,60%/0.25)]">
            <div
              className="calendly-inline-widget"
              data-url={`${BOOKING_URL}?hide_gdpr_banner=1&background_color=ffffff&primary_color=2563eb&text_color=1a1a2e`}
              style={{ minWidth: "320px", height: "660px" }}
            />
          </div>
        </motion.div>

        {/* WhatsApp alternative */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-center mt-8"
        >
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-blue-400 hover:text-blue-300 transition-colors underline underline-offset-4"
          >
            ¿Preferís hablar con un asesor? Escribinos por WhatsApp.
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CalendlySection;
